import { useEffect } from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import { mergeClassnames } from '@mote/helpers/dom'
import styled from '@xstyled/styled-components'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'
import { useDialogContext } from './DialogProvider'

export interface DialogContentProps extends HTMLXStyledProps<'div'> {}

export const DialogContent = forwardRef<DialogContentProps, 'div'>(
  (props, ref) => {
    const { className, ...rest } = props
    const { setContentMounted, getDialogContentProps, scrollBehavior } =
      useDialogContext()

    const contentProps = getDialogContentProps(rest, ref)

    useEffect(() => {
      setContentMounted(true)
      return () => setContentMounted(false)
    }, [setContentMounted])

    const _className = mergeClassnames('mote-dialog__content', className)

    return (
      <DialogContentRoot
        {...contentProps}
        overflow={scrollBehavior === 'inside' ? 'auto' : undefined}
        ref={ref}
        className={_className}
      />
    )
  }
)

if (__DEV__) {
  DialogContent.displayName = 'DialogContent'
}

const DialogContentRoot = styled.divBox`
  flex: 1 1 0%;
  padding: 8px 24px;

  button.mote-dialog__close-button + & {
    padding-top: 48px;
  }

  &:first-child {
    padding-top: 24px;
  }

  &:last-child {
    padding-bottom: 24px;
  }
`
